import { render, staticRenderFns } from "./MercSettlementCalc.vue?vue&type=template&id=8b8dd734&scoped=true"
import script from "./MercSettlementCalc.vue?vue&type=script&lang=js"
export * from "./MercSettlementCalc.vue?vue&type=script&lang=js"
import style0 from "./MercSettlementCalc.vue?vue&type=style&index=0&id=8b8dd734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8dd734",
  null
  
)

export default component.exports